<!-- Top Bar -->
<div class="bg-primary-800 text-white text-sm">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex justify-between items-center">
    <div class="flex items-center gap-6">
      <a href="tel:45814646" class="flex items-center gap-2 hover:text-primary-200 transition-colors">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
        </svg>
        Tlf. 45 81 46 46
      </a>
      <a href="mailto:info@financeone.dk" class="flex items-center gap-2 hover:text-primary-200 transition-colors">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
        </svg>
        info&#64;financeone.dk
      </a>
    </div>
  </div>
</div>

<!-- Main Header -->
<header class="bg-primary-700 text-white shadow-lg sticky top-0 z-50">
  <nav class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex justify-between items-center h-16">
      <!-- Logo -->
      <div class="flex-shrink-0">
        <a routerLink="/" class="text-2xl font-extrabold text-white hover:text-primary-100 transition-all duration-300">
          Finance ONE
        </a>
      </div>

      <!-- Desktop Navigation -->
      <div class="hidden md:flex items-center space-x-8">
        <a routerLink="/" routerLinkActive="text-primary-200" [routerLinkActiveOptions]="{exact: true}" class="text-white hover:text-primary-200 transition-colors">
          Hjem
        </a>
        <a routerLink="/funktioner" routerLinkActive="text-primary-200" class="text-white hover:text-primary-200 transition-colors">
          Funktioner
        </a>
        <a routerLink="/priser" routerLinkActive="text-primary-200" class="text-white hover:text-primary-200 transition-colors">
          Priser
        </a>
        <a routerLink="/guides" routerLinkActive="text-primary-200" class="text-white hover:text-primary-200 transition-colors">
          Guides
        </a>
        <a routerLink="/nyheder" routerLinkActive="text-primary-200" class="text-white hover:text-primary-200 transition-colors">
          Nyheder
        </a>
        <a routerLink="/kontakt" routerLinkActive="text-primary-200" class="text-white hover:text-primary-200 transition-colors">
          Kontakt
        </a>
        <a routerLink="/tilmelding-som-virksomhed" class="inline-flex items-center justify-center bg-white text-primary-700 px-6 py-2.5 rounded-full font-bold shadow-lg hover:shadow-primary-300/50 hover:scale-105 transition-all duration-200 text-base border border-primary-500">
          Tilmeld din virksomhed
        </a>
      </div>

      <!-- Mobile menu button -->
      <div class="md:hidden">
        <button 
          (click)="toggleMobileMenu()" 
          class="text-white hover:text-primary-200 p-2"
          aria-label="Toggle menu"
        >
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path *ngIf="!mobileMenuOpen" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
            <path *ngIf="mobileMenuOpen" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
    </div>

    <!-- Mobile Navigation -->
    <div *ngIf="mobileMenuOpen" class="md:hidden pb-4 bg-primary-700">
      <div class="flex flex-col space-y-4">
        <a routerLink="/" (click)="closeMobileMenu()" routerLinkActive="text-primary-200" [routerLinkActiveOptions]="{exact: true}" class="text-white hover:text-primary-200 transition-colors py-2">
          Hjem
        </a>
        <a routerLink="/funktioner" (click)="closeMobileMenu()" routerLinkActive="text-primary-200" class="text-white hover:text-primary-200 transition-colors py-2">
          Funktioner
        </a>
        <a routerLink="/priser" (click)="closeMobileMenu()" routerLinkActive="text-primary-200" class="text-white hover:text-primary-200 transition-colors py-2">
          Priser
        </a>
        <a routerLink="/guides" (click)="closeMobileMenu()" routerLinkActive="text-primary-200" class="text-white hover:text-primary-200 transition-colors py-2">
          Guides
        </a>
        <a routerLink="/nyheder" (click)="closeMobileMenu()" routerLinkActive="text-primary-200" class="text-white hover:text-primary-200 transition-colors py-2">
          Nyheder
        </a>
        <a routerLink="/kontakt" (click)="closeMobileMenu()" routerLinkActive="text-primary-200" class="text-white hover:text-primary-200 transition-colors py-2">
          Kontakt
        </a>
        <a routerLink="/tilmelding-som-virksomhed" (click)="closeMobileMenu()" class="self-start inline-flex items-center justify-center bg-white text-primary-700 px-6 py-2.5 rounded-full font-bold shadow-lg hover:shadow-primary-300/50 hover:scale-105 transition-all duration-200 text-base border border-primary-500">
          Tilmeld din virksomhed
        </a>
      </div>
    </div>
  </nav>
</header>
